import { getKPIRequest } from "@/api/getKPIRequest.ts"
import type { KPI, KPIGroupRequest } from "@/types/kpiTypes.ts"

import type { DailyChartConfig } from "../types/dailyChartTypes.ts"

export const getChartData = async (config: DailyChartConfig): Promise<KPI[]> => {
  const req: KPIGroupRequest = {
    returnSize: config.days,
    aggType: "Daily",
    kpis: config.kpis,
  }

  return await getKPIRequest(req)
}
